var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.availability.length ? _c('div', {
    staticClass: "availability-content"
  }, [_vm.isCurrentCityAvailable ? [_vm.currentCityStoreList.length ? [_c('div', {
    staticClass: "availability-content__subtitle"
  }, [_vm._v("\n        " + _vm._s(_vm.title) + "\n      ")]), _vm._v(" "), _c('ul', {
    staticClass: "availability-content__list"
  }, _vm._l(_vm.currentCityStoreList, function (item, index) {
    return _c('li', {
      key: index,
      staticClass: "availability-content__el"
    }, [_c('div', {
      staticClass: "availability-content__address"
    }, [_vm._v("\n            " + _vm._s(item.name) + "\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "availability-content__status",
      style: ("color: " + (item.color) + ";")
    }, [_vm._v("\n            " + _vm._s(item.value) + "\n          ")])]);
  }), 0)] : _vm._e(), _vm._v(" "), _vm.anotherCityStoreList.length ? [_c('div', {
    staticClass: "fz-14 lh-16 b mb-10",
    class: {
      'mt-18': _vm.currentCityStoreList.length
    }
  }, [_vm._v("\n        " + _vm._s('В других городах') + "\n      ")]), _vm._v(" "), _c('ul', {
    staticClass: "availability-content__list"
  }, _vm._l(_vm.anotherCityStoreList, function (item, index) {
    return _c('li', {
      key: index,
      staticClass: "availability-content__el"
    }, [_c('div', {
      staticClass: "availability-content__address"
    }, [_vm._v("\n            " + _vm._s(item.name) + "\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "availability-content__status",
      style: ("color: " + (item.color) + ";")
    }, [_vm._v("\n            " + _vm._s(item.value) + "\n          ")])]);
  }), 0)] : _vm._e()] : [_c('div', {
    staticClass: "fz-14 lh-16 b mb-10",
    class: {
      'mt-18': _vm.currentCityStoreList.length
    }
  }, [_vm._v("\n      " + _vm._s('В других городах') + "\n    ")]), _vm._v(" "), _c('ul', {
    staticClass: "availability-content__list"
  }, _vm._l(_vm.availability, function (item, index) {
    return _c('li', {
      key: index,
      staticClass: "availability-content__el"
    }, [_c('div', {
      staticClass: "availability-content__address"
    }, [_vm._v("\n          " + _vm._s(item.name) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "availability-content__status",
      style: ("color: " + (item.color) + ";")
    }, [_vm._v("\n          " + _vm._s(item.value) + "\n        ")])]);
  }), 0)]], 2) : _c('span', {
    staticClass: "grey-text"
  }, [_vm._v("Нет в наличии на складах или в магазинах")]);
}
var staticRenderFns = []

export { render, staticRenderFns }